import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiPresentationLogic } from "./IsiPresentationLogic";
import { IsiButtonType, IsiModeConfirm, IsiIconType } from "../../Isilog.enums";

/**
 * Gestion de l'action "supprimer" sur le menu des DA 
 * */
export class IsiPlDelete extends IsiPresentationLogic {

    constructor() {
        super("IsiPlDeleteHandler");
    }

    /**
     * demande la confirmation de suppression
     */
    public deleteOnDetail(): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            window.sCodeLibelleStatus = DELETING;

            uiCore.showConfirm({
                message: uiCore.getMessage("DARMess", "Supprime").IsiLabel,
                iconType: IsiIconType.Question,
                confirmMode: IsiModeConfirm.YesNo,
                callback: function (reponse) {
                    resolve({ result: true, continue: reponse === IsiButtonType.Yes });
                }
            });
        });
    }
    
}